export default __webpack_public_path__ + "static/media/cooper-5.d51b666a.jpg";